
/* ===== Header ===== */
/* ===== Sidebar ===== */

/* ===== Header ===== */
export const openedMixin = (theme, sidebarwidth) => ({
  backgroundColor: theme.palette.primary.main,
  width: sidebarwidth,
  borderRadius: 'var(--headerbr) 0 0 0',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflow: 'hidden',
  position: 'relative',
});

/* ===== Sidebar ===== */
export const sidebarwidth = '310px';

export const headerBox = {
  p: 2,
  height: 'inherit',
  width: sidebarwidth,
  color: 'white',
};
export const sideBarLogo = {
  left: '50%',
  transform: 'translate(-50%, 100px)',
  transition: '1s',
  width: '90px',
  height: 'auto',
  zIndex: 11362,
  backgroundColor: 'var(--primaryblue)',
  padding: '10px',
  position: 'absolute',
  opacity: '1'
};
